module.exports = __webpack_public_path__ + "images/jdf-logo-green@1x2ac23ae8c013ec796660b28c2d1325fe.png";